module.exports = __webpack_public_path__ + "img/terrace1.7101877b.png";